module.exports = __webpack_public_path__ + "dc0cff6d2cfd9c469ab615af08e0a3ea.MP3";